import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@mantine/core';
import StatusScreen from '@/components/common/StatusScreen';
import { ROUTES } from '@/routes/paths';
import { useAuth } from '@/stores/authContext';

// Страница не найдена. Вошедшего ведём в кабинет (перевозчика туда уведёт маршрут кабинета), гостя — на главную.
// Пока сессия восстанавливается, кнопки нет: неясно, кто перед нами.
export default function NotFound() {
  const { t } = useTranslation();
  const { isAuthenticated, isInitializing } = useAuth();

  // Адрес может подойти под раздел (/app/deals/5/x), поэтому заголовок вкладки задаёт сама страница.
  useEffect(() => {
    document.title = `${t('notFound.title')} — ${t('app.name')}`;
  }, [t]);

  return (
    <StatusScreen
      title={t('notFound.title')}
      message={t(isAuthenticated ? 'notFound.messageSignedIn' : 'notFound.message')}
    >
      {isInitializing ? null : (
        <Button component={Link} to={isAuthenticated ? ROUTES.APP : ROUTES.HOME}>
          {t(isAuthenticated ? 'notFound.toCabinet' : 'notFound.backHome')}
        </Button>
      )}
    </StatusScreen>
  );
}
